import { SkipToContentButton } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SkipToContentButton/SkipToContentButton";

export { SkipToContentButton };
